import script from "./UserIdentifyLoginMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserIdentifyLoginMobile.vue?vue&type=script&lang=ts&setup=true"

import "./UserIdentifyLoginMobile.vue?vue&type=style&index=0&id=035f36d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035f36d4"]])

export default __exports__